import React from 'react';
import PlatformService from 'src/services/platform-service';

interface Props {
  college: {
    loc?: [number, number];
  };
}

const CollegeMap = ({college}: Props) => {
  if (!college.loc) {
    return null;
  }

  const key =
    PlatformService.runtime() === 'ios'
      ? 'AIzaSyDi42jkHlASMq1TiCkUEYcBi7pDQSpl_Ag'
      : 'AIzaSyC5W5zNGvxuJ8jVWpFSLQxTBbfW9l47WI0';

  return (
    <div className="college-profile-map">
      <iframe
        title="Google Maps"
        width="100%"
        height="242"
        style={{border: '0'}}
        src={`https://www.google.com/maps/embed/v1/view?key=${key}&zoom=12&center=${college.loc[1]},${college.loc[0]}`}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default CollegeMap;
